/* Copyright (c) 2017 Backpack Health LLC */

/* global window IS_ANDROID_BUILD */
import React from 'react';
import * as _ from 'lodash';

import './ShareCardTemplate.scss';

import { ScrollAwareContext, ScrollAwareItem, ScrollAwareScroller } from '../../../components/ScrollAware';
import { ShareCardColorModel } from '../../../appAuthorized/dataTransformComponents/ColorShareCard';
import ContentLoader from '../../../components/ContentLoader';

interface Props {
  shareCardColorModel: ShareCardColorModel;
  scrollAwareHeader: any;
  shareCardFooter: any;
  isContentLoaded: boolean;
  shareCardId: number;
  disableScrolling: boolean;
}

const VERTICAL_OFFSET = IS_ANDROID_BUILD ? 4 : 32;
const VERTICAL_OFFSET_WITH_FOOTER = 74 + VERTICAL_OFFSET;

class ShareCardTemplate extends React.Component<Props, {}> {
  scrollRef: any;

  constructor(props) {
    super(props);

    this.scrollRef = React.createRef();
  }

  public scrollPos = () => {
    return this.scrollRef.current.scrollPos();
  }

  public animateScrollTo = (destinationPos, forceDuration) => {
    this.scrollRef.current.animateScrollTo(destinationPos, forceDuration);
  }

  public scrollBy = (destinationPos) => {
    this.scrollRef.current.scrollBy(destinationPos);
  }

  render() {
    const { scrollAwareHeader, disableScrolling, shareCardFooter, isContentLoaded, shareCardColorModel, shareCardId, children } = this.props;
    return (
      <ScrollAwareContext usesWindowScrolling={false}>
        <div className="cmp-sharecardtemplate" id={shareCardId.toString()}>
          <ScrollAwareItem hasDropShadow={true} isNav={true} isRelative={true}>
            {scrollAwareHeader}
          </ScrollAwareItem>

            <ContentLoader isContentLoaded={isContentLoaded} transparentChildren={true} />

            <ScrollAwareScroller
              ref={this.scrollRef}
              className=" "
              heightOffset={shareCardFooter ? VERTICAL_OFFSET_WITH_FOOTER : VERTICAL_OFFSET}
              disableScrolling={disableScrolling}
              outerStyle={{ width: '100%', display: 'flex', flexGrow: 1, backgroundColor: shareCardColorModel.cssColor(0.05), overflow: 'auto' }}
              innerStyle={{ borderBottomLeftRadius: 8, borderBottomRightRadius: 8, height: '100%' }}
            >
              <div
                style={{
                  top: 0,
                  bottom: 58,
                }}
              >
                {children}
              </div>
            </ScrollAwareScroller>

          {shareCardFooter}
        </div>

      </ScrollAwareContext>
    );
  }
}

export default ShareCardTemplate;
